package modysy.model

import modysy.view.{Color, ImageProvider}

/**
  * Models a circular game object with predefined radius and colour.
  *
  * @param lifetime lifetime of the portal
  */
class Portal(val isEntrance: Boolean)
    extends FixedShapeGameObject(
      new RigidBody(
        Transform.identity,
        Velocity.zero,
        Material(Double.PositiveInfinity, 1), //with density = 0 the portal disappears on contact.
        Circle(50)),
      "rgb(183,45,183)"
    ) {
  var rotation = 0;

  /**
    * Behaviour when colliding with other game objects.
    *
    * @param other game object the portal is colliding with
    */
  override def onCollision(other: GameObject): Unit = {
    other.body.pose.translate((50, 50))
  }

  /**
    * Renders the game object with an image.
    *
    * @param ctx Canvas Rendering Context
    */
  override def render(ctx: Ctx2D): Unit = {
    super.render(ctx);
    rotation += 1;
    if (rotation >= 360) rotation = 0
    ctx.save()
    //ctx.globalAlpha = 0.5

    ctx.translate(body.pose.translation.x, body.pose.translation.y)
    ctx.rotate(rotation * Math.PI / 180)
    if (isEntrance) {
      ImageProvider
        .drawImgFnc(ImageProvider.getImage("portal-in"), 100, 100)
        .apply(ctx, -50, -50)
    } else {
      ImageProvider
        .drawImgFnc(ImageProvider.getImage("portal-out"), 100, 100)
        .apply(ctx, -50, -50)
    }
    ctx.restore()
  }

  //TODO: Add lifetime bar?

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/Portal.scala